/**
 * @file 开发者社区 获取帮助
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import { IGetHelp } from './../../types';

import './style.less';

const DeveloperHelp: React.FC<IGetHelp> = props => {
    const { title, list = [] } = props;

    return (
        <div className="developer-community-help">
            <div className="get-help-title">{title}</div>
            <div className="help-card-wrapper">
                    {
                        list.map(item => <div className="open-source-and-cooperation-card" key={item.title}>
                            <img className={`help-icon`} src={item.icon} alt="" />
                            <div className="help-content">
                                <p className="help-card-title">{item.title}</p>
                                <p className="help-card-desc">{item.text}</p>
                                <div {...{dangerouslySetInnerHTML:{__html: item.extra ?? ''}}}></div>
                            </div>
                        </div>)
                    }
            </div>
        </div>
    );
};

export default DeveloperHelp;